import React, { useState, useEffect } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { Switch } from '../components/ui/switch';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import api from '../lib/api';

const CONFIG_ITEMS = [
  { key: 'maker_checker_enabled', label: 'Enable Maker-Checker', type: 'boolean', description: 'Globally enable maker-checker approval workflow' },
  { key: 'max_clients_per_office', label: 'Max Clients per Office', type: 'number', description: 'Maximum number of clients per office' },
  { key: 'min_loan_amount', label: 'Minimum Loan Amount (ZAR)', type: 'number', description: 'Minimum allowable loan amount' },
  { key: 'min_loan_amount', label: 'Minimum Loan Amount (ZAR)', type: 'number', description: 'Enforced at loan application. Leave 0 to disable.' },
  { key: 'max_loan_amount', label: 'Maximum Loan Amount (ZAR)', type: 'number', description: 'Enforced at loan application. Leave 0 to disable.' },
  { key: 'loan_arrears_tolerance_days', label: 'Loan Arrears Tolerance (Days)', type: 'number', description: 'Grace days before a loan is marked in arrears by batch processing' },
  { key: 'enable_audit_trail', label: 'Enable Audit Trail', type: 'boolean', description: 'Track all system actions (always active)' },
  { key: 'auto_generate_account_numbers', label: 'Auto-Generate Account Numbers', type: 'boolean', description: 'Automatically generate client and loan account numbers (always active)' },
  { key: 'batch_processing_enabled', label: 'Enable Batch Processing', type: 'boolean', description: 'Runs: interest accrual, standing instructions, monthly fees, provisioning, deposit interest' },
  { key: 'maker_checker_enabled', label: 'Enable Maker-Checker Globally', type: 'boolean', description: 'When off, submitter can approve own entries. See Configure Maker-Checker Tasks for per-task control.' },
];

const ConfigurationsPage = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);
  const load = async () => {
    setLoading(true);
    try { const res = await api.get('/global-configurations'); setConfig(res.data || {}); }
    catch (e) { setConfig({}); }
    setLoading(false);
  };

  const handleSave = async () => {
    try { await api.put('/global-configurations', config); toast.success('Configuration saved'); }
    catch (e) { toast.error('Failed to save'); }
  };

  return (
    <AdminSubPage title="Configurations" breadcrumb={['Admin', 'System', 'Configurations']} backPath="/dashboard/admin/system" actionLabel="Save" onAction={handleSave}>
      {loading ? <div className="text-center py-8 text-gray-400">Loading...</div> : (
        <div className="bg-white border border-gray-200 divide-y">
          {CONFIG_ITEMS.map(item => (
            <div key={item.key} className="flex items-center justify-between px-6 py-4">
              <div><div className="text-sm font-medium text-[#1f1f1f]">{item.label}</div><div className="text-xs text-gray-400">{item.description}</div></div>
              {item.type === 'boolean' ? (
                <Switch checked={!!config[item.key]} onCheckedChange={v => setConfig({...config, [item.key]: v})} data-testid={`cfg-${item.key}`} />
              ) : (
                <Input type="number" value={config[item.key] || ''} onChange={e => setConfig({...config, [item.key]: e.target.value})} className="w-32 text-right" data-testid={`cfg-${item.key}`} />
              )}
            </div>
          ))}
        </div>
      )}
    </AdminSubPage>
  );
};
export default ConfigurationsPage;
